import {merge} from '#core/utils/config-utils.js';
import {icon} from '#core/utils/style-utils.js';
import {resolveBackground} from '#core/utils/color-utils.js';

import {generateBetBuilderSelectionItem} from '#core/application/modules/tiles/bet-builder-selection-item/index.js';
import {generateNeutralVenueIndicator} from '#core/application/modules/tiles/neutral-venue-indicator/index.js';
import {generateBorder} from '#core/application/modules/tiles/border/index.js';
import {generatePriceBoostBanner} from '#core/application/modules/tiles/price-boost-banner/index.js';
import {generateOddsButton} from '#core/application/modules/tiles/odds-button/index.js';
import {generateSecondaryLink} from '#core/application/modules/tiles/link/index.js';

export function preBuiltCardsFactory(PALETTE, COLOR_MODE) {
    return {
        PrebuiltBetClassic: merge(generatePrebuiltBetClassicDetails(PALETTE, PALETTE.PREBUILT_CARD_DETAILS_LIGHT), {
            mode: COLOR_MODE,
            showBackgroundSportImage: !PALETTE.PARENT.CARD_WATERMARK_ICON_HIDDEN,
            prebuiltBetDetailsDark: generatePrebuiltBetClassicDetails(PALETTE, PALETTE.PREBUILT_CARD_DETAILS_DARK),
        }),
        PrebuiltBetBuilderClassic: merge(
            generatePrebuiltBetBuilderClassicDetails(PALETTE.PREBUILT_CARD_DETAILS_LIGHT),
            {
                matchAccaIcon: {
                    style: {
                        width: 16,
                        height: 16,
                    },
                },
                prebuiltBetBuilderDetailsDark: generatePrebuiltBetBuilderClassicDetails(
                    PALETTE.PREBUILT_CARD_DETAILS_DARK
                ),
            }
        ),
        PrebuiltAccaClassic: merge(generatePrebuiltAccaClassicDetails(PALETTE.PREBUILT_CARD_DETAILS_LIGHT), {
            prebuiltAccaDetailsDark: generatePrebuiltAccaClassicDetails(PALETTE.PREBUILT_CARD_DETAILS_DARK),
        }),
        PrebuiltBetsSkeleton: {
            container: {
                style: {
                    padding: '0 0 2px 0',
                    _mobile_padding: '0 8px 2px 0',
                },
            },
            cardContainer: {
                style: {
                    ...resolveBackground(PALETTE.PREBUILT_CARD_CONTAINER_BG),
                    ...generateBorder(PALETTE.PREBUILT_CARD_BORDER),
                },
            },
        },
    };
}

function generateShowAllSelectionsButton(CARD_DETAILS) {
    return {
        button: merge(generateSecondaryLink(CARD_DETAILS.SHOW_MORE_BUTTON), {
            style: {
                base: {
                    alignItems: 'center',
                },
            },
        }),
        buttonLabel: {
            style: CARD_DETAILS.SHOW_MORE_BUTTON.SECONDARY_LINK_TEXT,
        },
        buttonIcon: icon(CARD_DETAILS.SHOW_MORE_BUTTON.SECONDARY_LINK_ICON_COLOR),
    };
}

function generatePrebuiltBetClassicDetails(PALETTE, CARD_DETAILS) {
    const SHOW_ALL_SELECTIONS_BUTTON = generateShowAllSelectionsButton(CARD_DETAILS);

    return {
        genericEventCard: {
            container: {
                itemSpacing: 8,
                style: {
                    ...resolveBackground(PALETTE.PREBUILT_CARD_CONTAINER_BG),
                    ...generateBorder(PALETTE.PREBUILT_CARD_BORDER),
                },
            },
        },
        matchAccaSelectionsContainer: {
            style: {
                flexGrow: 0,
            },
        },
        matchAccaSelectionItem: merge(generateBetBuilderSelectionItem(CARD_DETAILS.SELECTION_ITEM), {
            marketInfoContainer: {
                style: {
                    padding: 0,
                },
            },
            marketName: {
                style: CARD_DETAILS.SELECTION_MARKET_NAME_TEXT,
            },
            selectionLabel: {
                style: {
                    overflowWrap: 'anywhere',
                },
            },
        }),
        selectionContentContainer: {
            style: {
                padding: '0 8px 8px',
            },
        },
        selectionButton: generateOddsButton(CARD_DETAILS.ODDS_BUTTON),
        priceBoostBanner: merge(generatePriceBoostBanner(PALETTE.CARD_PREBUILT_PRICE_BOOST_BANNER), {
            priceBoostContainer: {
                style: {
                    zIndex: 1,
                },
            },
        }),
        showAllSelectionsButton: {
            showAllButton: SHOW_ALL_SELECTIONS_BUTTON,
            hideAllButton: SHOW_ALL_SELECTIONS_BUTTON,
        },
    };
}

function generatePrebuiltBetBuilderClassicDetails(CARD_DETAILS) {
    return {
        headerContainer: {
            style: {
                flexGrow: 0,
            },
        },
        participantsIconInline: {
            participantName: {
                style: CARD_DETAILS.EVENT_NAME_TEXT,
            },
            separator: {
                style: CARD_DETAILS.EVENT_NAME_TEXT,
            },
        },
        promotionText: {
            style: CARD_DETAILS.EVENT_NAME_TEXT,
        },
        startTime: {
            style: CARD_DETAILS.EVENT_INFO_TEXT,
        },
        matchAccaIcon: icon(CARD_DETAILS.BB_BET_ICON_COLOR, 'system-betbuilder'),
        typeName: {
            style: CARD_DETAILS.EVENT_INFO_TEXT,
        },
        neutralVenueIndicator: generateNeutralVenueIndicator(CARD_DETAILS.BB_NEUTRAL_VENUE_INDICATOR),
    };
}

function generatePrebuiltAccaClassicDetails(CARD_DETAILS) {
    return {
        view: {
            matchAccaSelectionItem: {
                marketName: {
                    style: CARD_DETAILS.ACCA_SELECTION_MARKET_TEXT,
                },
                eventName: {
                    style: CARD_DETAILS.ACCA_SELECTION_EVENT_TEXT,
                },
            },
        },
        headerContainer: {
            style: {
                flexGrow: 0,
            },
        },
        promotionText: {
            style: CARD_DETAILS.EVENT_NAME_TEXT,
        },
        marketName: {
            style: CARD_DETAILS.ACCA_HEADER_TEXT,
        },
    };
}
